export default class MenuModel {
  constructor(param: any) {
    // @ts-ignore
    this.url = param.url;
    // @ts-ignore
    this.name = param.name;
    // @ts-ignore
    this.icon = param.icon;
    // @ts-ignore
    this.children = this.createChildren(param.children);
    // @ts-ignore
    this.order = param.sort;
    // @ts-ignore
    this.active = param.default;
    // @ts-ignore
    this.routing = param.routing;
    // @ts-ignore
    this.key = param.key;
    // @ts-ignore
    this.iconKey = param.iconKey;
  }

  createChildren(children: any) {
    if (children == null) {
      return null;
    }

    let result = [];
    for (let i = 0; i < children.length; i++) {
      result.push(new MenuModel(children[i]));
    }

    // @ts-ignore
    return result.sort((a, b) => (a.order > b.order && 1) || -1);
  }
}
